
import { Component, Vue } from 'vue-property-decorator'
import StageService from '@/api/services/StageService'

@Component({
})
export default class Home extends Vue {
    protected service = new StageService()

    async created (): Promise<void> {
        const response = await this.service.getStageConnection()
        if (response.length > 0) {
            location.assign(response)
        }
    }
}
